module.exports = __webpack_public_path__ + "serviceworker.js";